import React from "react"
import AgenciesMarquee from "../agencies-marquee"

const PerformanceSection = () => {
  return (
    <section className="py-5">
      {/* Desktop */}
      <h1
        className="is-hidden-touch is-size-2-desktop has-text-weight-semibold has-text-centered pt-5"
        style={{ textAlign: "center", lineHeight: "1.2" }}
      >
        <span className="text-dark-blue">
          Agencies Maximizing Outcomes with AI PMPs
        </span>
      </h1>

      {/* Mobile */}
      <h1
        className="is-hidden-desktop is-size-6-mobile is-size-3-tablet has-text-weight-semibold has-text-centered pb-5"
        style={{ textAlign: "center", lineHeight: "1.2" }}
      >
        <span className="text-dark-blue">
          Agencies Maximizing Outcomes with AI PMPs
        </span>
      </h1>

      <section>
        <AgenciesMarquee title="" />
      </section>
    </section>
  )
}

export default PerformanceSection
